import { render, staticRenderFns } from "./MenageReport.vue?vue&type=template&id=5fcce6fa&scoped=true"
import script from "./MenageReport.vue?vue&type=script&lang=js"
export * from "./MenageReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fcce6fa",
  null
  
)

export default component.exports